import { LengthUnit, WeightUnit } from '@src/util/weight'

export class ClubInfoDTO {
  addressLine1?: string
  addressLine2?: string
  addressLine3?: string
  addressPostcode?: string
  addressTownCity?: string
  addressCountry?: string

  constructor (attributes) {
    // Only include fields that have values (not empty, null, or undefined)
    if (attributes.addressLine1 && typeof attributes.addressLine1 === 'string' && attributes.addressLine1.trim()) {
      this.addressLine1 = attributes.addressLine1
    }
    if (attributes.addressLine2 && typeof attributes.addressLine2 === 'string' && attributes.addressLine2.trim()) {
      this.addressLine2 = attributes.addressLine2
    }
    if (attributes.addressLine3 && typeof attributes.addressLine3 === 'string' && attributes.addressLine3.trim()) {
      this.addressLine3 = attributes.addressLine3
    }
    if (attributes.addressPostcode && typeof attributes.addressPostcode === 'string' && attributes.addressPostcode.trim()) {
      this.addressPostcode = attributes.addressPostcode
    }
    if (attributes.addressTownCity && typeof attributes.addressTownCity === 'string' && attributes.addressTownCity.trim()) {
      this.addressTownCity = attributes.addressTownCity
    }
    if (attributes.addressCountry && typeof attributes.addressCountry === 'string' && attributes.addressCountry.trim()) {
      this.addressCountry = attributes.addressCountry
    }
  }
}

export class ClubGeneralSettingsDTO {
  screenExerciseLen: number
  screenCountdownLen: number
  screenSummaryLen: number
  weightUnit: string
  heightUnit: string
  stationLayout: string
  displayPixScore: boolean
  smileyId: number

  constructor (attributes) {
    this.screenExerciseLen = attributes.screenExerciseLen
    this.screenCountdownLen = attributes.screenCountdownLen
    this.screenSummaryLen = attributes.screenSummaryLen
    this.weightUnit = attributes.weightUnit
    this.heightUnit = this.weightUnit === WeightUnit.KG ? LengthUnit.IN : LengthUnit.CM
    this.stationLayout = attributes.stationLayout
    this.displayPixScore = attributes.displayPixScore
    this.smileyId = attributes.smileyId
  }
}

export class ClubScheduleDTO {
  sundayShutdownTime: string
  mondayShutdownTime: string
  tuesdayShutdownTime: string
  wednesdayShutdownTime: string
  thursdayShutdownTime: string
  fridayShutdownTime: string
  saturdayShutdownTime: string
  sundayBootTime: string
  mondayBootTime: string
  tuesdayBootTime: string
  wednesdayBootTime: string
  thursdayBootTime: string
  fridayBootTime: string
  saturdayBootTime: string
  enableShutdownTime: boolean

  constructor (attributes) {
    this.sundayShutdownTime = attributes.sundayShutdownTime
    this.mondayShutdownTime = attributes.mondayShutdownTime
    this.tuesdayShutdownTime = attributes.tuesdayShutdownTime
    this.wednesdayShutdownTime = attributes.wednesdayShutdownTime
    this.thursdayShutdownTime = attributes.thursdayShutdownTime
    this.fridayShutdownTime = attributes.fridayShutdownTime
    this.saturdayShutdownTime = attributes.saturdayShutdownTime
    this.sundayBootTime = attributes.sundayBootTime
    this.mondayBootTime = attributes.mondayBootTime
    this.tuesdayBootTime = attributes.tuesdayBootTime
    this.wednesdayBootTime = attributes.wednesdayBootTime
    this.thursdayBootTime = attributes.thursdayBootTime
    this.fridayBootTime = attributes.fridayBootTime
    this.saturdayBootTime = attributes.saturdayBootTime
    this.enableShutdownTime = attributes.enableShutdownTime
  }
}
